module.exports = __webpack_public_path__ + "img/kl_blct.fedff9fe.png";